import Head from 'next/head';

export default function SEO({ title, description, keywords }) {
  return (
    <Head>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="robots" content="index, follow" />
      <meta name="p:domain_verify" content="31cf41200b6a1e61d7dfc5832b3f69f3"/>
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="language" content="English"></meta>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta name="keywords" content={keywords} />
    </Head>
  );
}
